<app-header></app-header>
<div class="container-fluid">
  <div class="row">
    <div
      class="aside col-12 col-md-6 bg-light-blue padding-2 d-none d-md-block"
    >
      <!--<img class="width-50" src="assets/img/logo.svg" />-->
    </div>

    <div class="col-12 col-md-6 padding-2">
      <div class="container-form margin-auto">
        <h2 class="margin-top-2 text-center">{{ "login" | translate }}</h2>
        <!-- Image -->
        <div class="flex-center form-group">
          <!-- <img class="width-80" src="assets/img/logo.svg" /> -->

          <!-- Form -->
          <form [formGroup]="form">
            <!-- Email -->
            <mat-form-field appearance="legacy" class="margin-top-1">
              <mat-label>{{ "email" | translate }}</mat-label>
              <input
                matInput
                formControlName="email"
                name="email"
                autocomplete="email"
                class="form-control"
              />
              <mat-error *ngIf="emailNoValido">
                {{ "valid-email" | translate }}
              </mat-error>
            </mat-form-field>

            <!-- Password -->
            <mat-form-field appearance="legacy" class="margin-top-1">
              <mat-label>{{ "password" | translate }}</mat-label>
              <input
                matInput
                formControlName="password"
                type="password"
                name="password"
                class="form-control"
                autocomplete="current-password"
              />
              <mat-error *ngIf="passwordNoValido">
                {{ "valid-password" | translate }}
              </mat-error>
            </mat-form-field>

            <!-- Forget Password -->
            <div class="text-4 margin-top-05 text-center">
              <a class="a" [routerLink]="['/auth/recover-password']">
                {{ "forget-password" | translate }}
              </a>
            </div>

            <div class="row justify-content-center m-0">
              <!-- Send Form -->
              <button
                mat-raised-button
                color="primary"
                class="width-50 margin-top-2 margin-bottom-1 padding-05 text-uppercase"
                [class.spinner]="loading"
                type="submit"
                (click)="login()"
              >
                <span>{{ "login" | translate }}</span>
              </button>
            </div>
          </form>
        </div>
        <!-- Other Logins -->

        <div class="crossed-bg flex-center margin-vertical-1" *ngIf="!ios">
          <span>{{ "or" | translate }}</span>
        </div>


        <div class="flex-space-around other-logins" *ngIf="!ios">
          <button mat-icon-button (click)="loginGoogle()">
            <mat-icon svgIcon="google"></mat-icon>
          </button>
          <button mat-icon-button (click)="loginFacebook()">
            <mat-icon svgIcon="facebook"></mat-icon>
          </button>
          <!-- <button mat-icon-button (click)="loginApple()">
  <mat-icon svgIcon="apple"></mat-icon>
</button> -->
        </div>

        <div class="margin-top-2 mat-title text-center">
          {{ "not-account-yet" | translate }}
        </div>
        <!-- Open Modal -->
        <div class="row justify-content-center m-0">
          <button
            mat-raised-button
            color="accent"
            class="width-50 margin-top-1 padding-05 text-uppercase register-icon"
            (click)="openDialog(modal)"
          >
            <span> {{ "register-me" | translate }} </span>
          </button>
        </div>
        <!-- <button mat-raised-button color="accent" class="width-100 margin-top-1"
(click)="general.navigate('/auth/register-teacher')">
<span> {{'register-me'|translate}}
</span>
</button> -->
      </div>
    </div>
  </div>
</div>

<ng-template #modal let-modal>
  <div class="modal-header">
    <h3 class="modal-title flex-center">
      {{ "select-type-register" | translate }}
    </h3>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.close('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body flex-space-around">
    <button
      mat-raised-button
      color="primary"
      class="flex-center register-icon"
      [routerLink]="['/auth/register-teacher']"
      (click)="modal.close('teacher click')"
    >
      <mat-icon svgIcon="teacher"></mat-icon>
      {{ "teacher" | translate }}
    </button>

    <button
      mat-raised-button
      color="primary"
      class="flex-center register-icon"
      [routerLink]="['/auth/register-student']"
      (click)="modal.close('student click')"
    >
      <mat-icon svgIcon="student"></mat-icon>
      {{ "student" | translate }}
    </button>
  </div>
</ng-template>
